import cache from "../../utils/cache";
import apis from "../../request/apis";

export default {
    namespaced: true,
    state: {
        type: cache.getSession("brandtype") || [], //品牌类型
    },

    mutations: {
        changeBrandType(state, payload) {
            state.type = payload;
            cache.setSession("brandtype", state.userinfo);
        }
    },

    actions: {
        getBrandType(store, params) {
            return new Promise((resolve, reject) => {
                apis.brand.getBrandContentType({
                    datacenter_uuid: store.rootState.common.datacenteruuid
                }).then(res => {
                    store.commit("changeBrandType", res.data.list);
                    resolve(res.data.records);
                }).catch(reject);
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/brand.js